<div role="dialog" aria-modal="true" aria-labelledby="modal-title-plans-assignment">
  <div class="modal-header">
    <h2 id="modal-title-plans-assignment" class="modal-title h4">Plans Assignment</h2>
  </div>
  <form #ngForm="ngForm" (ngSubmit)="ngForm.valid && submit()">
    <div class="modal-body">
      <span>Needed By</span>
      <em-datepicker class="mt-2" [(ngModel)]="startDate" [minDate]="minDate" name="StartDate"> </em-datepicker>
      <label class="info-box">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          <span>The date you can commit to start buildout. In some constrained live regions, approval may expire in 7 days.</span>
      </label>
      <div class="alert alert-info d-flex align-items-start" role="alert">
        <div>If you assign a Growth blueprint with the same version as a previous assignment, a new execution plan will be created.</div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="ngForm.invalid" data-test="Submit">OK</button>
      <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
    </div>
  </form>
</div>
